/**
 * Andamento do lote na tela do lote (CHAN-122): enquanto ele não termina, só o estado e a
 * contagem dos contadores da própria linha do lote (modo summary), sem lista por envelope.
 */
export const BATCH_PROGRESS_POLL_MS = 15000;

export function isBatchTerminal(status) {
  return status === 'finished' || status === 'canceled';
}

export function batchStatusLabel(status) {
  return status === 'creating' ? 'Em preparação' : status;
}

const fmt = (n) => Number(n).toLocaleString('pt-BR');

/**
 * Linhas de contagem por fase. Sem total_count (lote em voo no deploy) não há contagem,
 * e a contagem nunca passa do total (a reconciliação pode corrigir deriva).
 */
export function batchProgressLines(batch) {
  const total = batch?.total_count;
  if (total == null) return [];
  const linha = (n, texto) => `${fmt(Math.min(n ?? 0, total))} de ${fmt(total)} documentos ${texto}`;
  if (batch.status === 'pending') return [linha(batch.generated_count, 'gerados')];
  if (batch.status === 'processing') {
    // Automático com fast-path: geração e assinatura correm juntas
    const gerando = (batch.generated_count ?? 0) < total;
    return [...(gerando ? [linha(batch.generated_count, 'gerados')] : []), linha(batch.finished_count, 'finalizados')];
  }
  return [];
}
